























































































import Vue from 'vue';
import Component from 'vue-class-component';
import * as rules from '@/modules/shared/shared/domain/rules';
import SectionTitle from '@/modules/shared/shared/components/SectionTitle.vue';
import CustomerSelection from '@/modules/reports/health-reports/components/CustomersSelection.vue';
import { layout } from '@/modules/shared/shared/store/namespaces';
import { LayoutMutations } from '@/modules/shared/layouts/store/layout.mutations';
import { LayoutTitle } from '@/modules/shared/layouts/domain/layout-title';
import { healthReports } from '@/modules/reports/shared/store/namespaces';
import { HealthReportsActions } from '@/modules/reports/health-reports/store/health-reports.actions';
import { HealthReportUpload } from '@/modules/reports/health-reports/domain/health-report-upload';
import { EventBus } from '@/main';
import { EventBusMessages } from '@/modules/shared/shared/domain/constants/event-bus-messages';
import moment from 'moment';
import { Watch } from 'vue-property-decorator';

@Component({
    name: 'upload-health-report',
    components: { CustomerSelection, SectionTitle },
})
export default class UploadHealthReport extends Vue {
    private rules: any = rules;

    private quarters = [
        {
            name: 'Primer trimestre',
            month: 1,
        },
        {
            name: 'Segundo trimestre',
            month: 4,
        },
        {
            name: 'Tercer trimestre',
            month: 7,
        },
        {
            name: 'Cuarto trimestre',
            month: 10,
        },
    ];
    private month: number | null = null;
    private quarter: string | null = null;
    private year: number | null = null;

    private file: any = null;
    private picker: string[] = [];
    private menu: boolean = false;

    private isLoading: boolean = false;
    private isLoadingCustomers: boolean = false;

    $refs!: {
        customerSelection: any;
        form: any;
    };

    onFileChange(e) {
        if (e === null) {
            this.file = null;
        } else {
            this.file = e;
        }
    }

    async uploadFile() {
        this.isLoading = true;

        if (this.$refs.form.validate()) {
            const customerId = this.$refs.customerSelection.getSelectedCustomerId();
            if (customerId) {
                const failed = await this.uploadReport({
                    customerId,
                    file: this.file,
                    month: this.month!,
                    year: this.year!,
                });
                if (failed) {
                    failed.showError();
                } else {
                    this.$refs.form.reset();
                    this.$refs.customerSelection.reset();
                }
            }
        }
        this.isLoading = false;
    }

    dateChange(selectedDates: string[]) {
        let date = selectedDates.length > 1 ? selectedDates[3] : selectedDates[0];
        const quarter = moment(date).quarter() - 1;
        let dates: string[] = [];
        for (let i = 0; i < 3; i++) {
            dates.push(
                moment(date)
                    .month(quarter * 3 + i)
                    .format('YYYY-MM'),
            );
        }
        this.month =
            moment(date)
                .month(quarter * 3)
                .month() + 1;
        this.year = moment(date).year();
        this.quarter = `${this.quarters[quarter].name} de ${this.year}`;
        this.picker = dates;
    }

    mounted() {
        this.changeTitle({ route: ['Registro'], title: 'Informes de Salud y Gestión' });
    }

    @layout.Mutation(LayoutMutations.CHANGE_TITLE)
    changeTitle!: (layout: LayoutTitle) => void;

    @healthReports.Action(HealthReportsActions.UPLOAD_REPORT)
    uploadReport!: (report: HealthReportUpload) => Promise<RequestResponse>;
}
